import * as R from 'ramda';

/**
 * Zendesk config.
 */
const zendeskConfig = {
  key: '623a67d1-cb94-407b-84aa-f5f213b2207d',
  secret: R.defaultTo(
    '5427119f1b174bcf0f361a0a211dfa51',
    process.env.ZENDESK_CONFIG,
  ),
  name: 'TrueProdigy',
  email: 'sysadmin@trueprodigy.tech',
};

export default zendeskConfig;
